import styled from 'styled-components';
import { Grid } from '@mui/material';

export const typeaheadSuggestion = 1300;

export const ChipBar = styled(Grid)`
  display: flex;
  align-items: end;
  overflow-x: auto;
  flex-wrap: wrap;
  padding-top: 5px;
`;
